<h2 mat-dialog-title>{{ action }}</h2>
<mat-dialog-content>{{ data?.msg }}</mat-dialog-content>
<mat-dialog-actions>
    <button mat-stroked-button (click)="onClick(false)" class="cancel-btn">No</button>
    <button mat-flat-button color="primary" (click)="onClick(true)" cdkFocusInitial>Yes</button>
</mat-dialog-actions>
